import * as $runtime from "../runtime.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
const min = x => y => {
  const v = Data$dOrd.ordInt.compare(x)(y);
  if (v.tag === "LT") { return x; }
  if (v.tag === "EQ") { return x; }
  if (v.tag === "GT") { return y; }
  $runtime.fail();
};
const toDetails = v => v1 => (
  {
    name: v.name,
    prize: v.prize,
    value: (() => {
      if (v.prize.tag === "PriceDiscount") { return min(v1.totalAfterPromotions)(v.prize._1); }
      if (v.prize.tag === "PercentageDiscount") {
        return Data$dMoney$dRounded.roundCents(Data$dInt.toNumber(v.prize._1) * 0.01 * (Data$dInt.toNumber(v1.totalAfterPromotions) / 100.0) * 100.0);
      }
      $runtime.fail();
    })()
  }
);
export {min, toDetails};
